export const OrderIdModal = (props: { onClose: () => void; }) => {
    return (<div className="popup-modal">
        <div className="popup-modal__content modal-400">
            <button className="popup-modal__close modal-close-button" onClick={ () => props.onClose() }>
                <svg className="icon icon-close" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                    <path d="M14.0625 3.9375L3.9375 14.0625" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"></path>
                    <path d="M14.0625 14.0625L3.9375 3.9375" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
            </button>
            <div className="cart-popup-modal__content-info">
                <h3 className="cart-popup-modal__title h4">
                    Find your Order ID
                </h3>
                <div className="product-popup-modal__text">
                    <img width={'400px'} height={'auto'} src={(window as any).order_label_id_img_big} />
                </div>
            </div>
        </div>
    </div>);
}